import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { from, mergeMap, Observable } from 'rxjs';
import { SPARKET_BRIDGE_ENDPOINTS } from '../api/sparket-bridge/sparket-bridge-api';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { AuthService } from '../services/auth/auth.service';
import { SignedOutError } from 'src/app/common/errors/signed-out-error';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private analyticsService = inject(AnalyticsService);
  private authService = inject(AuthService);

  private readonly authenticatedUrls = [
    SPARKET_BRIDGE_ENDPOINTS.CREATE_TOKEN,
    SPARKET_BRIDGE_ENDPOINTS.PREPARE_DEPOSIT_FUNDS,
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.requiresAuth(request.url)) {
      return next.handle(request);
    }

    return from(this.tryGetToken(request.url)).pipe(
      mergeMap((token) => {
        const authRequest = token
          ? request.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
            })
          : request;
        return next.handle(authRequest);
      }),
    );
  }

  private requiresAuth(url: string): boolean {
    return this.authenticatedUrls.some((endpoint) => url.includes(endpoint));
  }

  private async tryGetToken(url: string): Promise<string> {
    const token = this.authService.sparketToken;
    if (!token) {
      const err = new SignedOutError(`User signed out from: ${url}`, url);
      this.analyticsService.handleError(err);
      throw err;
    }
    return token;
  }
}
